
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/mrmed",
      function () {
        return require("private-next-pages/case-study/mrmed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/mrmed"])
      });
    }
  